<template>
<div class="">
  <h5 class="center">Información general</h5>
  <br/>
  <b-form v-bind:id="'form-create'" @submit.prevent="callMethod">
    <b-row>
      <b-col md="5">
        <b-form-group v-bind:label="'Nombre del estudiante'">
          <b-input-group>
            <b-form-input type="text" required v-model="dataName" v-bind:placeholder="'Nombre del estudiante'"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group v-bind:label="'Saldo credencial'">
          <b-input-group>
            <b-form-input type="number" required v-model="dataSaldo" v-bind:name="'saldo'"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group v-bind:label="'Entrega inmediata?'">
          <b-form-select v-bind:name="'immediate'" v-model="dataImmediate" :options="options"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group v-bind:label="'¿Alistamiento?'">
          <b-form-select v-bind:name="'enlistment'" v-model="dataEnlistment" :options="options"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
  <hr>
</div>
</template>
<script>
import Form from '@/components/modules/base/form.vue'
export default {
  name: 'Forms',
  components: {
    Form
  },
  props: {
    dataParams: {}
  },
  data () {
    return {
      dataName: null,
      dataSaldo: null,
      dataImmediate: null,
      dataEnlistment: null,
      options: [
        {
          value: null,
          text: 'Seleccione una opcion'
        },
        {
          value: '1',
          text: 'Si'
        },
        {
          value: '0',
          text: 'No'
        }
      ]
    }
  },
  mounted () {
    let store = JSON.parse(localStorage.getItem('requestValidate'))
    console.log(store)
    this.name = ((store.name) ? store.name : null)
    this.saldo = ((store.saldo) ? store.saldo : null)
    this.immediate = ((store.immediate) ? store.immediate : null)
    this.enlistment = ((store.enlistment) ? store.enlistment : null)
  },
  computed: {
    name: {
      get: function () {
        return this.dataName
      },
      set: function (newValue) {
        this.dataName = newValue
      }
    },
    saldo: {
      get: function () {
        return this.dataSaldo
      },
      set: function (newValue) {
        this.dataSaldo = newValue
      }
    },
    immediate: {
      get: function () {
        return this.dataImmediate
      },
      set: function (newValue) {
        this.dataImmediate = newValue
      }
    },
    enlistment: {
      get: function () {
        return this.dataEnlistment
      },
      set: function (newValue) {
        this.dataEnlistment = newValue
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/papeleria/requests/form/general.vue